import { useEffect, useRef } from 'react';
import { connect, useDispatch } from 'react-redux';
import { fetchExpenseTypes, saveExpenseType } from '@redux/ducks/expenseType';
import ExpenseTypeForm from './components/ExpenseTypeForm';
import { TableForm, Button } from '@components';

const ExpenseType = props => {
  const { results, load_query, load_mutation } = props;
  const dispatch = useDispatch();
  const formRef = useRef(null);
  const listRef = useRef(null);

  function initialize() {
    window.scroll(0, 0);
    listRef.current.closeForm();
    dispatch(fetchExpenseTypes({}));
  }

  function onSave(data, edit) {
    return new Promise((resolve, reject) => {
      dispatch(
        saveExpenseType({
          data,
          edit,
          success: () => {
            initialize();
            resolve();
          },
          error: error => {
            reject(error);
          },
        })
      );
    });
  }

  async function edit(type) {
    await listRef.current.openForm();
    const { id, description, active, receipt } = type;

    setTimeout(() => {
      formRef?.current?.edit({
        id,
        description,
        active,
        receipt
      });
    }, 200);
  }

  useEffect(() => {
    initialize();
  }, []);

  return (
    <TableForm
      formHeader={{
        title: 'Tipo de despesa',
        subtitle: 'Gerencie e visualize os tipos de despesas',
      }}
      titleModal="Cadastro de tipo de despesa"
      source={results}
      load={load_query}
      ref={listRef}
      onNew={() => listRef.current.openForm()}
      headers={[
        { label: 'Descrição', getValue: item => item.description },
        {
          label: 'Informa comprovante',
          getValue: item => (item.receipt ? 'Sim' : 'Não'),
        },
        {
          label: 'Situação',
          getValue: item => (item.active ? 'Ativo' : 'Inativo'),
        },
        {
          label: 'Ações',
          props: {
            align: 'center',
            width: '70px',
          },
          getValue: item => (
            <Button compact onClick={() => edit(item)}>
              Editar
            </Button>
          ),
        },
      ]}
    >
      <ExpenseTypeForm
        formRef={formRef}
        onSubmit={(values, edit) => onSave(values, edit)}
        loadMutation={load_mutation}
      />
    </TableForm>
  );
};

function mapStateToProps({ expenseType }) {
  const { results, load_query, load_mutation } = expenseType;
  return {
    results,
    load_query,
    load_mutation,
  };
}

export default connect(mapStateToProps)(ExpenseType);
